/**
 * Event builder editor oturumu.
 *
 * Panel sunucudan nonce alir ve musteri sitesini `?supsis-editor=NONCE` ile acar.
 * Loader nonce'u public endpoint'ten dogrular ve yalnizca kayitli panel origin'i ile
 * postMessage yapar. Boylece rastgele bir sayfa loader'in editor modunu acamaz.
 */
import log2 from "../../../js/log2-lite";
import { buildUrl } from "../../utils";

const log = log2("TRACKER_EDITOR");

const QUERY_PARAM = "supsis-editor";
const NONCE_REGEX = /^[a-f0-9]{32}$/;

/** URL'deki editor nonce'u. */
export function readNonce() {
    try {
        const nonce = new URLSearchParams(window.location.search).get(QUERY_PARAM);
        return nonce && NONCE_REGEX.test(nonce) ? nonce : null;
    } catch (e) {
        return null;
    }
}

/**
 * @returns {Promise<String|null>} dogrulanmis panel origin'i
 */
export function verifyNonce(siteId, nonce) {
    const url =
        buildUrl("public/web-analytics/editor-session/" + encodeURIComponent(nonce)) +
        "?siteId=" +
        encodeURIComponent(siteId);

    return fetch(url)
        .then(function (response) {
            if (!response || response.status !== 200) return null;
            return response.json();
        })
        .then(function (payload) {
            if (!payload || payload.valid !== true || !payload.origin) return null;
            return payload.origin;
        })
        .catch(function (e) {
            log.debug("editor session verify failed", e);
            return null;
        });
}

/**
 * Panel ile iki yonlu mesajlasma kanali.
 * Hedef: sekmeyi acan pencere (window.opener); iframe icinde acildiysa parent.
 */
class EditorChannel {
    constructor() {
        this.nonce = null;
        this.origin = null;
        this.target = null;
        this.handler = null;
    }

    open(nonce, origin, handler) {
        this.nonce = nonce;
        this.origin = origin;
        this.handler = handler;
        this.target = window.opener || (window.parent !== window ? window.parent : null);

        if (!this.target) {
            log.debug("editor channel has no target window");
            return false;
        }

        const self = this;
        window.addEventListener("message", function (event) {
            // Yalnizca dogrulanmis panel origin'i ve ayni nonce kabul edilir
            if (event.origin !== self.origin) return;
            const data = event.data;
            if (!data || typeof data !== "object") return;
            if (data.nonce !== self.nonce) return;
            if (typeof data.type !== "string" || data.type.indexOf("editor:") !== 0) return;

            try {
                self.handler(data);
            } catch (e) {
                log.debug("editor message failed", { type: data.type, message: e.message });
            }
        });

        return true;
    }

    send(type, payload) {
        if (!this.target) return;
        try {
            this.target.postMessage(
                Object.assign({ type: type, nonce: this.nonce, source: "supsis-editor" }, payload || {}),
                this.origin
            );
        } catch (e) {
            log.debug("editor postMessage failed", e);
        }
    }
}

export const editorChannel = new EditorChannel();



//////////////////
// WEBPACK FOOTER
// ./static/src/tracker/editor/session.js
// module id = null
// module chunks = 